import React, { Fragment } from 'react'
import { Route, useRouteMatch } from 'react-router'
import MainLayout from '../../layouts/MainLayout'
import SplitView from '../../layouts/SplitView/SplitView'
import SideNavigation from '../../common/SideNavigation'
import AdminSideMenu from '../../../constants/AdminSideMenu'

// Containers
import Dashboard from './Dashboard'
import AllApplications from './AllApplications'
import ApplicationDetail from './ApplicationDetail'
import Publish from './Publish'
import PublishSettings from './PublishSettings'
import PendingReviews from './PendingReviews'
import PendingReviewDetail from './PendingReviewDetail'

const Admin = () => {
  const routeMatch = useRouteMatch()

  return (
    <MainLayout>
      <SplitView withSideNav={true}>
        <SplitView.Left>  
          <SideNavigation 
            categories={AdminSideMenu}
          />
        </SplitView.Left>
        <SplitView.Right>
          <Fragment>
            <Route path={`${routeMatch.path}/dashboard`} component={Dashboard} exact={true} />
            <Route path={`${routeMatch.path}/all-applications`} component={AllApplications} exact={true} />
            <Route path={`${routeMatch.path}/all-applications/:releaseId`} component={ApplicationDetail} exact={true} />
            <Route path={`${routeMatch.path}/all-applications/publish/:releaseId`} component={Publish} exact={true} />
            <Route path={`${routeMatch.path}/all-applications/publish/settings/:releaseId/:platformId`} component={PublishSettings} exact={true} />
            <Route path={`${routeMatch.path}/pending-reviews`} component={PendingReviews} exact={true} />
            <Route path={`${routeMatch.path}/pending-reviews/:releaseId`} component={PendingReviewDetail} exact={true} />
          </Fragment>
        </SplitView.Right>
      </SplitView>
    </MainLayout>
  )
}

export default Admin